import React from 'react';
import { ShippingInputs } from 'swag-client-common/components/partials/shipment-inputs/shipping-inputs';
import WavedLoading from 'swag-client-common/components/info/waved-loading';
import { GiveawayPaper } from '../giveaway-paper/giveaway-paper';
import { GiveawayFormError } from '../giveaway-form-error';
import { ScrollingWrapper } from '../scrolling-wrapper';
import { ScrollBlockId } from '../../../middleware/window-manipulations.middleware';
import classes from './giveaway-shipping-form.scss';
const placeholderFieldCreator = sign => (placeholderNameParam, isRequired = false) => {
  const placeholderName = !placeholderNameParam.includes('Office') ? placeholderNameParam : 'Office, Floors Etc';
  if (!isRequired) {
    return placeholderName;
  }
  return `${placeholderName}${sign}`;
};
export default class GiveawayShippingForm extends React.PureComponent {
  render() {
    const {
      error,
      values,
      hasError,
      withEmail,
      autocompleteList,
      isAddressLoading,
      isAddressEnteredManually,
      onEdit,
      onManualEnterClick,
      onAddressSelect,
      onAddressFetch,
      onAddressClick,
      onShippingFormFocus,
      onShippingNameEdit,
      onShippingStateEdit,
      onShippingCountryEdit,
      isGoodieGiveaway,
      deliveryInternationalError
    } = this.props;
    return /*#__PURE__*/React.createElement(ScrollingWrapper, {
      scrollBlock: ScrollBlockId.giveawayValidationBlock
    }, /*#__PURE__*/React.createElement(GiveawayPaper, {
      className: classes.paper
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.heading
    }, "Where would you like us to send it?"), hasError && /*#__PURE__*/React.createElement(GiveawayFormError, {
      error: `* ${error}`
    }), /*#__PURE__*/React.createElement(ShippingInputs, {
      values: values,
      onEdit: onEdit,
      onShippingFormFocus: onShippingFormFocus,
      onShippingNameEdit: onShippingNameEdit,
      onShippingStateEdit: onShippingStateEdit,
      onShippingCountryEdit: onShippingCountryEdit,
      inputClassName: classes.input,
      inputLineClassName: classes.line,
      selectClassName: classes.select,
      manualContainerClassName: classes.manualContainer,
      placeholderFieldCreator: placeholderFieldCreator,
      withEmail: withEmail,
      onAddressFetch: onAddressFetch,
      onAddressSelect: onAddressSelect,
      onManualEnterClick: onManualEnterClick,
      onAddressClick: onAddressClick,
      isAddressEnteredManually: isAddressEnteredManually,
      isAddressLoading: isAddressLoading,
      loadingComponent: () => /*#__PURE__*/React.createElement(WavedLoading, {
        className: classes.loading
      }),
      autocompleteList: autocompleteList,
      withPhone: true,
      onlyUsOption: isGoodieGiveaway,
      deliveryInternationalError: deliveryInternationalError
    })));
  }
}